import { render, staticRenderFns } from "./EditableEditor.vue?vue&type=template&id=67d9c9fa&scoped=true"
import script from "./EditableEditor.vue?vue&type=script&lang=js"
export * from "./EditableEditor.vue?vue&type=script&lang=js"
import style0 from "./EditableEditor.vue?vue&type=style&index=0&id=67d9c9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d9c9fa",
  null
  
)

export default component.exports